import { render, staticRenderFns } from "./unit-select.vue?vue&type=template&id=3963f3eb"
import script from "./unit-select.ts?vue&type=script&lang=ts&external"
export * from "./unit-select.ts?vue&type=script&lang=ts&external"
import style0 from "./unit-select.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports